import React, { useState } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { SecondaryButton } from "components/Buttons";
import { AIRoleBuilderModal } from "components/Missions/Roles/AIRoleBuilder";
import { RoleBuilderModal } from "components/Missions/Roles/TalentSimple/RoleBuilder";

/**
 * AIRoleBuilderButton
 *
 * @param {boolean}  withRoleBuilder  Open the Talent Simple role builder instead of the single-step modal
 */
const AIRoleBuilderButton = ({ withRoleBuilder, ...props }) => {
  const [showModal, setShowModal] = useState(false);
  const BuilderModal = withRoleBuilder ? RoleBuilderModal : AIRoleBuilderModal;

  return (
    <>
      <SecondaryButton onClick={() => setShowModal(true)}>
        <FormattedMessage
          id={withRoleBuilder ? "Missions.Roles.TalentSimple.RoleBuilder.CTA" : "AIRoleBuilder.Button.Label"}
        />
      </SecondaryButton>
      {showModal && <BuilderModal show onClose={() => setShowModal(false)} {...props} />}
    </>
  );
};

AIRoleBuilderButton.propTypes = {
  withRoleBuilder: PropTypes.bool,
};

export default AIRoleBuilderButton;
